export const DASHBOARD = 'dashboard';
export const PERFORMANCE = 'performance';
export const FINANCE = 'finance';
export const SETTINGS = 'settings';
